var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPdfAttachment = function SvgPdfAttachment(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.765v-.568c0-2.094 0-3.141.331-3.978.532-1.345 1.657-2.405 3.085-2.907C6.302 1 7.413 1 9.636 1c1.27 0 1.905 0 2.412.179a2.919 2.919 0 0 1 1.762 1.66c.19.478.19 1.077.19 2.273v3.653",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 8.059a2.353 2.353 0 0 1 2.353-2.353c.47 0 1.024.082 1.48-.04a1.179 1.179 0 0 0 .833-.833c.122-.457.04-1.01.04-1.481A2.353 2.353 0 0 1 9.06 1M2 15.118V13m0 0v-1.27c0-.4 0-.6.124-.723.123-.125.324-.125.723-.125h.565a1.059 1.059 0 1 1 0 2.118H2Zm12-2.118h-1.059c-.666 0-.998 0-1.205.207-.207.207-.207.54-.207 1.205V13m0 0v2.118m0-2.118h1.765m-3.882 0a2.118 2.118 0 0 1-2.118 2.118c-.264 0-.395 0-.494-.057-.235-.136-.212-.41-.212-.65v-2.823c0-.238-.023-.513.212-.65.099-.056.23-.056.494-.056A2.118 2.118 0 0 1 9.412 13Z",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgPdfAttachment;